// extracted by mini-css-extract-plugin
module.exports = {"tableScrollContainer":"EK_jVHTC","tableRoot":"sSnYbT6i","tableHeader":"IZe4HQdf","footerRow":"N0jEIQbJ","rankWrapper":"rvkmlNid","sectorName":"zlmmTfVd"};